import { useContext, useEffect, useState } from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { ActivityList } from "./types";
import ButtonGroup from "./ButtonGroup";
import ImageSelect from "./ImageSelect";
import usePopup from "../../../hooks/usePopup";
import {
  Button,
  CircularProgress,
  // CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation } from "react-query";
import { getActivityList, viewActivityFile } from "../../services";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import moment from "moment";
import { DrawingContainerContext } from ".";
import { useParams } from "react-router-dom";
import useAuthentication from "@hooks/useAuthentication";
export const dimension = {
  height: 400,
  width: 450,
};
function DrawingContainer() {
  const { encounterId } = useParams();
  const {user} = useAuthentication()
  const targetWidth = dimension.width;
  const targetHeight = dimension.height;
  const {
    setSearchParams,
    searchParams,
    canvasRef,
    strokeWidth,
    eraserWidth,
    operation,
    imageUrl,
    strokeColor,
    setImageDetails,
    setImageUrl,
  } = useContext(DrawingContainerContext);
  const { CustomModal, showSnackbar } = usePopup();
  const [list, setList] = useState<ActivityList[]>([]);
  const [selected, setSelected] = useState(-1);
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [viewUrl, setViewUrl] = useState("");
  const [editDetails, setEditDetails] = useState<{
    details: ActivityList | null;
    index: number;
  }>({
    details: null,
    index: -1,
  });
  const {
    mutate: fetchActivityList,
    data,
    isLoading,
  } = useMutation(getActivityList, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setList(result?.response?.list || []);
        setSearchParams((prev) => ({
          ...prev,
          refetch: false,
        }));
      } else {
        showSnackbar({
          message: "Failed to load image list",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      }
    },
  });

  const { mutate: showFile, isLoading: viewFileLoading } = useMutation(
    viewActivityFile,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          setViewUrl(`data:image/png;base64,${result.response?.content}`);
          setOpenView(true);
        } else {
          showSnackbar({
            message: "Failed to load image",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    }
  );

  const { mutate: fetchFile, isLoading: fetchFileLoading } = useMutation(
    viewActivityFile,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response?.content) {
          handleImageResizeFromUrl(
            `data:image/png;base64,${result.response?.content}` as string
          );
        } else {
          showSnackbar({
            message: "Failed to load image",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    }
  );

  // const handleDelete = (id: number, index: number) => {
  //   console.log(id);
  //   setSelected(index);
  //   setTimeout(() => {
  //     setSelected(-1);
  //   }, 3000);
  // };

  const handleChangePage = (_: unknown, pageNumber: number) => {
    setSearchParams({
      ...searchParams,
      pageNumber,
      refetch: true,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchParams((prev) => ({
      ...prev,
      pageSize,
      refetch: true,
    }));
  };

  const handleView = (data: ActivityList, index: number) => {
    setSelected(index);
    const splitedImageName = data?.fullBodyImage?.split("/") || [];
    setEditDetails({ details: data, index });
    setImageDetails({
      activityImageId: data.id,
      imgName: splitedImageName[splitedImageName.length - 1] || "",
    });
    showFile({
      bodyImg: data.fullBodyImage,
      id: data.id,
      clinicId:Number(user?.clinicId)
    });
  };

  const handleImageResizeFromUrl = (url: string) => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // Allow cross-origin requests

    img.src = url;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      if (ctx) {
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const resizedUrl = URL.createObjectURL(blob);
              console.log(resizedUrl);
              setImageUrl(resizedUrl);
              setOpen(true);
            }
          },
          "image/jpeg",
          0.8
        );
      }
    };

    img.onerror = () => {
      console.error("Failed to load image from URL.");
    };
  };

  const handleEdit = (data: ActivityList, index: number) => {
    setSelected(index);
    const splitedImageName = data?.fullBodyImage?.split("/") || [];
    setImageDetails({
      activityImageId: data.id,
      imgName: splitedImageName[splitedImageName.length - 1] || "",
    });
    fetchFile({
      bodyImg: data.fullBodyImage,
      id: data.id,
      clinicId:Number(user?.clinicId)
    });
  };

  const handleSecondEdit = () => { 
    if (Boolean(editDetails)) {
      setOpenView(false)
      
      setOpen(false)
      handleEdit(editDetails.details as ActivityList, editDetails.index);
    }
  };

  useEffect(() => {
    if (searchParams.refetch) {
      fetchActivityList({ ...searchParams,encounterId:parseInt(encounterId as string)});
    }
  }, [searchParams]);

  return (
    <>
      <CustomModal title="Activity" open={open} setOpen={setOpen}>
        <div className="grid grid-cols-12 gap-6 p-3">
          <div className="col-span-6">
            <ImageSelect />
          </div>
          <div className="col-span-6 flex flex-col gap-y-2 justify-center items-center ">
            <ButtonGroup />
            <ReactSketchCanvas
              canvasColor="transparent"
              // height="100%"
              // width="100%"
              ref={canvasRef}
              strokeWidth={strokeWidth}
              eraserWidth={eraserWidth}
              strokeColor={strokeColor}
              backgroundImage={imageUrl}
              className={`${operation}`}
              exportWithBackgroundImage={true}
              style={{
                height: dimension.height,
                width: dimension.width,
                border: "1px solid black",
              }}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal title="Preview" open={openView} setOpen={setOpenView}>
        <div
          className={`w-[${dimension.width}px] h-[${dimension.height}px] flex flex-col justify-end items-end p-3 gap-3`}
        >
          <img src={viewUrl} />
          <Button onClick={handleSecondEdit} disabled={fetchFileLoading} endIcon={fetchFileLoading ? <CircularProgress size={18}/> : <EditIcon />}>
            edit
          </Button>
        </div>
      </CustomModal>
      <TableContainer className="border rounded relative">
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((head: string, index: number) => (
                <TableCell
                  key={`tableheading${index}`}
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={heading.length}>
                {!open && (
                  <div className="flex justify-end items-center">
                    <Button
                      onClick={() => {
                        setImageUrl("");
                        setImageDetails(null);
                        setOpen(true);
                      }}
                      color="success"
                      endIcon={<AddCircleIcon />}
                    >
                      add
                    </Button>
                  </div>
                )}
              </TableCell>
            </TableRow>
            {list?.map((row, index: number) => (
              <TableRow
                key={`${row?.id}${index}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>
                  {index + 1 + searchParams.pageSize * searchParams.pageNumber}
                </TableCell>
                <TableCell>
                  {moment(row?.createdByDate).format("DD-MM-YYYY hh:mm A")}
                </TableCell>
                <TableCell>{row?.firstName}</TableCell>
                <TableCell>{row.fullBodyImage}</TableCell>
                <TableCell>
                  {/* {deleteLoading && selected == index ? (
                    <CircularProgress size={18} color="error" />
                  ) : (
                    <IconButton
                      color="primary"
                      onClick={() => {
                        handleDelete(row.id, index);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )} */}

                  {viewFileLoading && selected == index ? (
                    <IconButton>
                      <CircularProgress size={19} color="success" />
                    </IconButton>
                  ) : (
                    <Tooltip title="View">
                      <IconButton
                        color="success"
                        onClick={() => {
                          handleView(row, index);
                        }}
                      >
                        <RemoveRedEyeIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  {fetchFileLoading && selected == index ? (
                    <IconButton>
                      <CircularProgress size={19} />
                    </IconButton>
                  ) : (
                    <Tooltip title="Edit">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          handleEdit(row, index);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
<div
  className={
    isLoading
      ? "flex flex-col justify-end items-end border-t p-4"
      : "flex flex-col justify-end items-end border-t"
  }
>
  {isLoading ? (
    <CircularProgress size={18} />
  ) : (
    list.length > 0 && (
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data?.response?.totalCount ?? list.length}
        rowsPerPage={searchParams.pageSize}
        page={searchParams.pageNumber}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    )
  )}
</div>
      </TableContainer>
    </>
  );
}

export default DrawingContainer;

const heading = [
  "SL NO",
  "CREATED DATE",
  "PATIENT NAME",
  "FILE NAME",
  "OPTIONS",
];
